export function formatPrice(cents: number, currency: string, locale = "de") {
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

export function formatDateTime(
  value: string | Date,
  locale = "de",
  options?: Intl.DateTimeFormatOptions,
) {
  try {
    const date = typeof value === "string" ? new Date(value) : value;
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch {
    return typeof value === "string" ? value : value.toISOString();
  }
}
